(function ($) {
    $(function () {

        if (!$(".js-form-download").length) {
            return;
        }

        var hasLetterRegex = "[a-zA-ZÀ-ÖØ-öø-ÿ-]";
        function removeLetters(string) {
            var r = new RegExp(hasLetterRegex, "g");
            return string.replace(r, "");
        }

        function formatPhoneNumber(string) {
            return removeLetters(string).replace(" ", "");
        }

        $(document).on("keypress keyup blur", ".js-phone", function () {
            this.value = formatPhoneNumber(this.value);
        });

        function grabFormAsObject(jqueryForm, limitToFields = []) {
            const data = jqueryForm.serializeArray();
            const obj = {};

            data.forEach(item => {
                if (typeof obj[item.name] === 'undefined') {
                    obj[item.name] = item.value;
                } else {
                    obj[item.name] += `;${item.value}`;
                }
            });

            return obj;
        }

        $(document).on('keydown', 'input', function (e) {
            $(this).next().removeClass('error-text--active');
            $(this).prev().removeClass('label--has-error');
        });

        $(document).on('change', 'input[type="checkbox"]', function (e) {
            $('.form__item__checkbox label').removeClass('label--has-error');
            $('.form__item__checkbox .error-text').removeClass('error-text--active');
        });

        $('.js-form-download').submit(function (e) {
            e.preventDefault()

            var theForm = $(this);

            var data = grabFormAsObject(theForm);

            $.ajax({
                url: localize.ajax_url,
                type: "POST",
                data: {
                    action: "send_form",
                    data: data
                },
                error: function (response) {
                    $('.js-modal-is-error').removeClass('d-none');
                    $('.js-form-modal').iziModal('open');
                },
                success: function (data) {
                    var result = JSON.parse(data);
                    var fields = [...new Set(result['fields'])];

                    if (result['status'] == 'success') {
                        $(theForm).trigger("reset");
                        $(".error-text").removeClass("error-text--active");
                        $('.form__item label').removeClass('label--has-error');
                        top.location.href = localize.item_to_download;
                        $('.js-modal-is-success').removeClass('d-none');
                        $('.js-form-modal').iziModal('open');
                    } else{
                        $(fields).each(function (i, e) {
                            if(e.field == "acceptterms"){
                                $('.form__item__checkbox label').addClass('label--has-error');
                                $('.form__item__checkbox .error-text').addClass('error-text--active');
                                $('.form__item__checkbox .error-text--message').text(e.message);
                            } else {
                                $('.js-form-download').find(`[name=${e.field}]`).prev().addClass('label--has-error');
                                $('.js-form-download').find(`[name=${e.field}]`).next().addClass('error-text--active');
                                $('.js-form-download').find(`[name=${e.field}]`).siblings().children("p").text(e.message);
                            }
                        });
                    }

                    

                },
            });
        });
    });
})(jQuery);